export enum UrlTokens {
  taxonToken = "t",
  pathToken = "p",
  ticketToken = "ticketId",
  showExact = "showExact",
  search = "search"
}
